import lz_api from '@/api/lz_api.js'
import cmy_api from '@/api/cmy_api.js'
const api = {
	state: {
		// 全局变量接口
		api: {
			...cmy_api,
			...lz_api
		}
	},
	mutations: {
		SET_BREADCRUMB: (state, breadcrumb) => {
			state.breadcrumb = breadcrumb
		},
	},
	actions: {
		SET_BREADCRUMB({
			commit
		}, userInfo) {
			return new Promise((resolve, reject) => {
				commit('SET_BREADCRUMB')
				resolve()
			})
		}
	}
}

export default api



// WEBPACK FOOTER //
// ./src/store/modules/api.js